import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { acquisition as acquisitionApi } from "@/api";
import ActaStandardPage from "@/components/layout/ActaStandardPage";
import CommerceMetricCard from "@/components/commerce/CommerceMetricCard";
import { CheckCircle, Target, TrendUp, Users } from "@phosphor-icons/react";

export default function AcquisitionCampaignDetail() {
  const { campaignId } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    acquisitionApi.getCampaign(campaignId)
      .then(setCampaign)
      .catch((err) => setError(err?.response?.data?.detail || "Impossible de charger la campagne."));
  }, [campaignId]);

  if (!campaign) {
    return (
      <ActaStandardPage>
        <Link to="/app/acquisition/campaigns" className="text-sm font-bold text-[var(--do-accent)]">← Campagnes</Link>
        <p className="mt-4 text-sm text-[var(--do-muted)]">{error || "Chargement…"}</p>
      </ActaStandardPage>
    );
  }

  return (
    <ActaStandardPage testId="acquisition-campaign-detail">
      <Link to="/app/acquisition/campaigns" className="text-sm font-bold text-[var(--do-accent)]">← Campagnes</Link>
      <p className="label-eyebrow mt-4">Campagne</p>
      <h1 className="font-heading text-3xl font-black text-[var(--do-ink)]">{campaign.name}</h1>
      <p className="mt-2 text-sm text-[var(--do-muted)]">
        {[campaign.provider, campaign.channel].filter(Boolean).join(" · ") || "Provenance Acquisition"}
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <CommerceMetricCard label="Leads reçus" value={campaign.received} detail="Leads rattachés à cette campagne" icon={Users} />
        <CommerceMetricCard label="Affectés" value={campaign.assigned} detail="Passés dans Commerce" icon={CheckCircle} />
        <CommerceMetricCard label="Avec affaire" value={campaign.withOpportunity} detail={`${campaign.opportunityCount || 0} affaire(s) au total`} icon={Target} />
        <CommerceMetricCard label="Gagnés" value={campaign.withWon} detail={`${campaign.wonRate || 0}% des leads affectés`} icon={TrendUp} />
      </div>

      <section className="mt-6 overflow-hidden rounded-2xl border border-[var(--do-border)] bg-[var(--do-bg-solid)]">
        <div className="border-b border-[var(--do-border)] p-5">
          <h2 className="font-heading text-lg font-black text-[var(--do-ink)]">Leads de la campagne</h2>
        </div>
        <div className="divide-y divide-[var(--do-border)]">
          {(campaign.leads || []).map((lead) => (
            <Link
              key={lead.id}
              to={`/app/acquisition/leads/${lead.id}`}
              className="flex flex-col gap-1 p-4 hover:bg-[var(--do-accent-soft)] sm:flex-row sm:items-center sm:justify-between"
            >
              <div>
                <div className="font-bold text-[var(--do-ink)]">
                  {[lead.firstName, lead.lastName].filter(Boolean).join(" ") || lead.company || "Sans nom"}
                </div>
                <div className="text-xs text-[var(--do-muted)]">{lead.email || lead.phone || "Aucune coordonnée"}</div>
              </div>
              <span className="acta-status-badge">{lead.statusLabel || lead.status}</span>
            </Link>
          ))}
        </div>
      </section>
    </ActaStandardPage>
  );
}
